import { homeColors, homeFont, media } from './tokens'

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 1440,
    margin: '0 auto',
    padding: '40px 48px',
    color: homeColors.navy,
    [theme.breakpoints.down('sm')]: {
      padding: '24px 16px',
    },
  },
  content: {
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    fontFamily: homeFont,
    '& h1, & h2': {
      fontFamily: homeFont,
    },
  },
  resources: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '16px',
    [media.tablet]: {
      gridTemplateColumns: 'minmax(0, 1fr)',
    },
  },
})

export default styles
